import { useFormik } from 'formik';
import * as Yup from 'yup';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom'
import { addressFromValidatorOrderCreate } from '../../services/validatior/formValidator/authValidator';
import { toast } from 'react-toastify';
import { getPostalSectors } from '../../redux/reducers/postalSectorsSlice';
import GoogleAutoCompleteComp from '../../components/common/GoogleAutoComplete/GoogleAutoCompleteComp';
import { setSelectAddress } from '../../redux/reducers/createOrderSlice';
import { getProfileView, addAddress } from '../../redux/reducers/authSlice';
import FormPostal from '../BookingForm/FormPostal';
import CheckoutPagePostalAddress from './CheckoutPagePostalAddress';

const AddressComp = ({ createOrder, selectedCategory }) => {
    const [sortedLocations, setSortedLocations] = useState([])
    const { user, myprofile } = useSelector((state) => state.auth)
    const { postalData
    } = useSelector((state) => state.poastalSectorsLists);
    const dispatch = useDispatch()
    const { selectedAddress } = useSelector((state) => state.createOrderSlice)

    const [locations, setLocations] = useState(selectedAddress ?? {
        address: '',
        country: '',
        postalCode: '',
        isPrimary: true,
        isActive: true,
        location: {
            type: "Point",
            coordinates: [""]
        }
    })

    const hasMatchingSavedAddresses = myprofile?.customer?.locations?.some(
        (loc) => (loc.postalCode || '').replace(/\s+/g, '').toLowerCase() === (selectedAddress?.postalCode || '').replace(/\s+/g, '').toLowerCase()
    );

    const validationSchema = (selectedAddress?.isFromInput && !hasMatchingSavedAddresses)
        ? Yup.object().shape({
            postalCode: Yup.string().required("Postal code is required"),
            country: Yup.string().required("Country is required"),
            address: Yup.string().required("Address 1 is required"),
            title: Yup.string().required("Address name is required"),
            unitNo: Yup.string().required("Unit number is required"),
            generalLocation: Yup.string().required("Location is required")
        })
        : addressFromValidatorOrderCreate(myprofile, selectedAddress, 'validationSchema');

    const addFormik = useFormik({
        enableReinitialize: true,
        initialValues: addressFromValidatorOrderCreate(myprofile, selectedAddress, 'initialValues'),
        validationSchema: validationSchema,
        onSubmit: async (data) => {

            if (data.country === "SG") {
                data.country = "Singapore"
            }

            if (user && selectedAddress?.isFromInput) {
                const cleanStr = (str) => (str || '').replace(/\s+/g, '').toLowerCase();
                const matchingAddress = myprofile?.customer?.locations?.find(
                    (loc) =>
                        cleanStr(loc.postalCode) === cleanStr(selectedAddress.postalCode) &&
                        cleanStr(loc.address) === cleanStr(selectedAddress.address) &&
                        cleanStr(loc.unitNo) === cleanStr(selectedAddress.unitNo)
                );
                if (matchingAddress) {
                    dispatch(setSelectAddress({ selectedAddress: matchingAddress }));
                } else {
                    const apiData = {
                        address: data.address,
                        country: data.country || 'Singapore',
                        postalCode: data.postalCode || selectedAddress?.postalCode,
                        isPrimary: true,
                        generalLocation: data.generalLocation || sortedLocations[0]?.generalLocation || "",
                        isActive: true,
                        location: selectedAddress?.location || {
                            type: "Point",
                            coordinates: [""]
                        },
                        title: data.title,
                        unitNo: data.unitNo
                    };

                    const response = await dispatch(addAddress({ 
                        values: apiData, 
                        cusId: user?.customer?._id ?? user?.customer, 
                        dispatch 
                    }));

                    if (response.meta.requestStatus === 'fulfilled') {
                        const profileResponse = await dispatch(getProfileView());
                        const newLocations = profileResponse.payload?.result?.customer?.locations || [];
                        const savedLoc = newLocations.find(loc => 
                            cleanStr(loc.postalCode) === cleanStr(data.postalCode || selectedAddress?.postalCode) && 
                            cleanStr(loc.unitNo) === cleanStr(data.unitNo) && 
                            cleanStr(loc.address) === cleanStr(data.address)
                        );
                        if (savedLoc) {
                            dispatch(setSelectAddress({ selectedAddress: savedLoc }));
                        }
                    } else {
                        toast.error("Failed to save address. Please try again.");
                        return;
                    }
                }
            } else {
                dispatch(setSelectAddress(
                    {
                        selectedAddress: {
                            ...selectedAddress,
                            ...data
                        }
                    }
                ))
            }

            user && orderCreate()
        }

    })
    const handleAddress = (addressObj, address) => {
        if (addressObj?.postal_code) {
            setLocations({
                ...locations,
                address: address?.label,
                country: addressObj?.country,
                postalCode: addressObj?.postal_code,
                isPrimary: true,
                isActive: true,
                location: {
                    type: "Point",
                    coordinates: [Number(addressObj?.lng), Number(addressObj?.lat)]
                }
            })
            addFormik.setFieldValue("country", addressObj?.country)
            addFormik.setFieldValue("postalCode", addressObj?.postal_code)

            setSortedLocations(postalData.filter(item => item?.postalCode == addressObj?.postal_code.slice(0, 2)))
        }
        else if (!addressObj?.postal_code && address?.label) {
            toast.error('Try to search more precisely')
        }
    }


    useEffect(() => {
        dispatch(getPostalSectors())
    }, [])
    useEffect(() => {
        setSortedLocations(postalData.filter(item => item?.postalCode == selectedAddress?.postalCode.slice(0, 2)))


    }, [postalData])
    useEffect(() => {
        if (selectedAddress?.isFromInput)
            addFormik.setFieldValue("generalLocation", sortedLocations[0]?.generalLocation)

    }, [sortedLocations])

    const orderCreate = () => {
        if (user) {
            createOrder(addFormik.values.unitNo, addFormik.values.addressName)
        }
    }

    useEffect(() => {
        dispatch(getProfileView())
    }, [])

    useEffect(() => {
        dispatch(setSelectAddress(
            {
                selectedAddress: { ...selectedAddress, ...addFormik?.values }
            }))
    }, [addFormik?.values])

    return (
        <>
            <div className="auth-signup ch-f">
                <form onSubmit={addFormik.handleSubmit}>
                    <div className="acc-info">
                        <p>Your Address</p>
                        {
                            selectedAddress?.isFromInput ?
                                (hasMatchingSavedAddresses ? (
                                    <CheckoutPagePostalAddress />
                                ) : (
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="address" className="form-label">
                                                    Address Line 1 *
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="address"
                                                    name="address"
                                                    placeholder="Block / Street name"
                                                    onChange={addFormik.handleChange}
                                                    value={addFormik.values.address}
                                                />
                                                <p className='form-error-message'>{addFormik.touched.address && addFormik.errors.address}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="unitNo" className="form-label">
                                                    Floor/unit number/Building name *
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="unitNo"
                                                    name="unitNo"
                                                    placeholder="Floor/unit number/Building name"
                                                    onChange={addFormik.handleChange}
                                                    value={addFormik.values.unitNo}
                                                />
                                                <p className='form-error-message'>{addFormik.touched.unitNo && addFormik.errors.unitNo}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="postalCode" className="form-label">
                                                    Postal Code
                                                </label>
                                                <input
                                                    type="text"
                                                    disabled
                                                    className="form-control"
                                                    id="postalCode"
                                                    name="postalCode"
                                                    value={selectedAddress?.postalCode || ""}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="country" className="form-label">
                                                    Country
                                                </label>
                                                <input
                                                    type="text"
                                                    disabled
                                                    className="form-control"
                                                    id="country"
                                                    name="country"
                                                    value="Singapore"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="title" className="form-label">
                                                    Name of address *
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="title"
                                                    name="title"
                                                    placeholder="My Home / Office"
                                                    onChange={addFormik.handleChange}
                                                    value={addFormik.values.title}
                                                />
                                                <p className='form-error-message'>{addFormik.touched.title && addFormik.errors.title}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="generalLocation" className="form-label">
                                                    Location *
                                                </label>
                                                <select
                                                    aria-label="Default select example"
                                                    className="form-select"
                                                    name="generalLocation"
                                                    id="generalLocation"
                                                    value={addFormik.values.generalLocation || ""}
                                                    onChange={(e) => {
                                                        addFormik.setFieldValue("generalLocation", e.target.value);
                                                    }}
                                                >
                                                    <option value="">Select Location</option>
                                                    {sortedLocations.map((item) => (
                                                        <option key={item?.generalLocation} value={item?.generalLocation}>
                                                            {item?.generalLocation}
                                                        </option>
                                                    ))}
                                                </select>
                                                <p className='form-error-message'>{addFormik.touched.generalLocation && addFormik.errors.generalLocation}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))
                                :
                                <div className='location-item-wrap' >
                                    <div className="location-item-p w-100">
                                        <div className="location-item" style={{ cursor: 'auto' }}>
                                            <div >
                                                <p className={`item-title`}>{selectedAddress?.title}:</p>
                                                <p >
                                                    {selectedAddress?.address}
                                                </p>
                                                <p >
                                                    {selectedAddress?.unitNo}
                                                </p>
                                                <p >
                                                    Singapore {selectedAddress?.postalCode}
                                                </p>
                                                <p className={`item-generallocation`}>
                                                    {selectedAddress?.generalLocation}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        }
                        <div className="text-text">By proceeding, you agree to and verify you have read our <a href="https://www.oneheartcleaning.com.sg/terms" target="blank" style={{ cursor: "pointer" }} className="colour-red">Terms and Conditions</a> and <a href="https://www.oneheartcleaning.com.sg/privacy" target="blank" style={{ cursor: "pointer" }} className="colour-red">Privacy Policy</a>.</div>

                    </div>
                    {!user && <div className="acc-info">
                        <p>Notification</p>
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="terms-conditions"
                                name="terms"

                            />
                            <label
                                className="form-check-label"
                                htmlFor="terms-conditions"
                            >
                                Keep Me Update with news, special promotions via email or sms
                            </label>
                        </div>
                    </div>}
                    <div className="sign-bottom">
                        {!user && <div className="text-text">By signing up, you agree to and verify you have read our <a href="https://www.oneheartcleaning.com.sg/terms" target="blank" style={{ cursor: "pointer" }} className="colour-red">Terms and Conditions</a> and <a href="https://www.oneheartcleaning.com.sg/privacy" target="blank" style={{ cursor: "pointer" }} className="colour-red">Privacy Policy</a>.</div>}
                        <div className="sign-up-btn d-block d-lg-flex align-items-center justify-content-between text-center mb-4">
                            <div className="pay-wrap">
                                <img src="/assets/images/pay.png" alt="" />
                            </div>
                            <button disabled={addFormik.isSubmitting} type={!user && "submit"} className="btn rounded-pill">{!user ? "Sign Up" : selectedCategory?.toLowerCase() === 'professional' ? "Submit" : "Pay"}</button>
                        </div>

                    </div>
                </form>
            </div>
        </>
    )
}

export default AddressComp